import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import ModuleView from "@/pages/ModuleView";
import LessonView from "@/pages/LessonView";
import QuizView from "@/pages/QuizView";
import Coach from "@/pages/Coach";
import Tools from "@/pages/Tools";
import MyNotes from "@/pages/MyNotes";
import Certificate from "@/pages/Certificate";
import Verify from "@/pages/Verify";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AdminLicenses from "@/pages/AdminLicenses";
import AdminStats from "@/pages/AdminStats";
import AdminPricing from "@/pages/AdminPricing";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Auth />} />
            <Route path="/verify/:certId" element={<Verify />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/module/:moduleId" element={<ProtectedRoute><ModuleView /></ProtectedRoute>} />
            <Route path="/module/:moduleId/lesson/:lessonId" element={<ProtectedRoute><LessonView /></ProtectedRoute>} />
            <Route path="/module/:moduleId/quiz" element={<ProtectedRoute><QuizView /></ProtectedRoute>} />
            <Route path="/coach" element={<ProtectedRoute><Coach /></ProtectedRoute>} />
            <Route path="/tools" element={<ProtectedRoute><Tools /></ProtectedRoute>} />
            <Route path="/notizen" element={<ProtectedRoute><MyNotes /></ProtectedRoute>} />
            <Route path="/zertifikat" element={<ProtectedRoute><Certificate /></ProtectedRoute>} />
            <Route path="/zahlung/erfolg" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
            <Route path="/admin/licenses" element={<ProtectedRoute><AdminLicenses /></ProtectedRoute>} />
            <Route path="/admin/stats" element={<ProtectedRoute><AdminStats /></ProtectedRoute>} />
            <Route path="/admin/pricing" element={<ProtectedRoute><AdminPricing /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
